import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import clienteAxios from "../../../config/axios";
import RegistrarProducto from "./services/registrar_producto";
import ActualizarProducto from "./services/actualizar_producto";
import {
  /* Card, */
  Row,
  Input,
  Button,
  Modal,
  Drawer,
  /* Result, */
  notification,
  Spin,
} from "antd";
import Pagination from "../../../components/Pagination/pagination";
/* import { StepsContext, StepsProvider } from '../contexts/stepsContext'; */
/* import {
  formatoMexico,
  agregarPorcentaje,
} from "../../../config/reuserFunction"; */
import { IdProductoContext } from "../contexts/ProductoContext";
import {
  ExclamationCircleOutlined,
  /*  EditOutlined,
  DeleteOutlined, */
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import jwt_decode from "jwt-decode";
import queryString from "query-string";
import "./productos.scss";
/* import aws from "../../../config/aws"; */
import TablaProductosAdmin from "./TablaProductos";

const { Search } = Input;
const { confirm } = Modal;
/* const gridStyle = { width: "100%", padding: 0, marginBottom: "1.5rem" }; */

function RegistrarProductos(props) {
  //Tomar la paginacion actual
  const { location, history } = props;
  const { page = 1 } = queryString.parse(location.search);

  const [productoID, setProductoID] = useState("");
  /* const [ disabled, setDisabled ] = useContext(StepsContext); */
  const [disabled, setDisabled] = useState(true);
  const [productos, setProductos] = useState([]);
  const [productosRender, setProductosRender] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [accion, setAccion] = useState(false);
  const [reload, setReload] = useState(false);
  const token = localStorage.getItem("token");
  const [reloadData, setReloadData] = useState(false);
  const [closeDraw, setCloseDraw] = useState(false);

  var decoded = Jwt(token);

  function Jwt(token) {
    try {
      return jwt_decode(token);
    } catch (e) {
      return null;
    }
  }

  if (token === "" || token === null) {
    props.history.push("/entrar");
  } else if (decoded["rol"] !== true) {
    props.history.push("/");
  }

  function closeConfirm() {
    confirm({
      title: "Estás seguro de cerrar esta ventana?",
      icon: <ExclamationCircleOutlined />,
      okText: "Si",
      okType: "danger",
      cancelText: "No",
      onOk() {
        drawnerClose();
      },
    });
  }

  function drawnerClose() {
    setVisible(false);
    setReload(true);
  }
  function setActualizar() {
    setAccion(true);
    setVisible(true);
  }
  function setRegistrar() {
    setAccion(false);
    setVisible(true);
  }

  const eventoCloseConfirm = () => {
    if (accion) {
      drawnerClose();
    } else {
      closeConfirm();
    }
  };

  if (closeDraw) {
    drawnerClose();
    setCloseDraw(false);
  }

  function showDeleteConfirm(idproducto) {
    confirm({
      title: "Estas seguro de eliminar este articulo?",
      icon: <ExclamationCircleOutlined />,
      content: "Este articulo sera borrado permanentemente",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        setLoading(true);
        await clienteAxios
          .delete(`/productos/${idproducto}`, {
            headers: {
              Authorization: `bearer ${token}`,
            },
          })
          .then((res) => {
            setLoading(false);
            if (window.screen.width < 768) {
              obtenerProductos(12, page);
            } else {
              obtenerProductos(28, page);
            }
            notification.success({
              message: res.data.message,
              duration: 2,
            });
          })
          .catch((err) => {
            setLoading(false);
            if (err.response) {
              notification.error({
                message: "Error",
                description: err.response.data.message,
                duration: 2,
              });
            } else {
              notification.error({
                message: "Error de conexion",
                description: "Al parecer no se a podido conectar al servidor.",
                duration: 2,
              });
            }
          });
      },
    });
  }

  const obtenerProductosFiltrados = async (busqueda) => {
    if (!busqueda) {
      if (window.screen.width < 768) {
        obtenerProductos(12, page);
      } else {
        obtenerProductos(28, page);
      }
    } else {
      setLoading(true);
      await clienteAxios
        .get(
          `/productos/search/admin?codigo=${busqueda}&nombre=${busqueda}&categoria=${busqueda}&subcategoria=${busqueda}&genero=${busqueda}&color=${busqueda}&temporada=${busqueda}`
        )
        .then((res) => {
          setProductosRender(res.data.posts);
          setProductos(res.data.posts);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (err.response) {
            notification.error({
              message: "Error",
              description: err.response.data.message,
              duration: 2,
            });
          } else {
            notification.error({
              message: "Error de conexion",
              description: "Al parecer no se a podido conectar al servidor.",
              duration: 2,
            });
          }
        });
    }
  };

  const obtenerProductos = async (limit, page) => {
    setReloadData(false);
    setLoading(true);
    await clienteAxios
      .get(`/productos/get/admin?limit=${limit}&page=${page}`)
      .then((res) => {
        setProductosRender(res.data.posts.docs);
        setProductos(res.data.posts);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response) {
          notification.error({
            message: "Error",
            description: err.response.data.message,
            duration: 2,
          });
        } else {
          notification.error({
            message: "Error de conexion",
            description: "Al parecer no se a podido conectar al servidor.",
            duration: 2,
          });
        }
      });
  };

  useEffect(() => {
    if (window.screen.width < 768) {
      obtenerProductos(12, page);
    } else {
      obtenerProductos(28, page);
    }
    setReload(false);
  }, [page, reload, reloadData]);

  return (
    <Spin size="large" spinning={loading}>
      <Drawer
        forceRender
        title={
          accion === true
            ? "Actualizar un producto"
            : "Registra un nuevo producto"
        }
        width={window.screen.width > 768 ? 1000 : window.screen.width}
        placement={"right"}
        onClose={eventoCloseConfirm}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          >
            <Button onClick={eventoCloseConfirm} type="primary">
              Cerrar
            </Button>
          </div>
        }
      >
        {accion === true ? (
          <IdProductoContext.Provider value={productoID}>
            <ActualizarProducto
              reloadProductos={reload}
              closeDraw={setCloseDraw}
            />
          </IdProductoContext.Provider>
        ) : (
          <RegistrarProducto
            reloadProductos={reload}
            disabledButtons={[disabled, setDisabled]}
            closeDraw={setCloseDraw}
          />
          /* <StepsProvider value={[ disabled, setDisabled ]}>
						<RegistrarProducto reloadProductos={reload} disabledButtons={[ disabled, setDisabled ]} />
					</StepsProvider> */
        )}
      </Drawer>
      <Row justify="space-between">
        <Search
          placeholder="Busca un producto"
          onSearch={(value) => obtenerProductosFiltrados(value)}
          style={{ height: 40, marginBottom: 10 }}
          enterButton={<SearchOutlined style={{ fontSize: 22 }} />}
          className="search-width"
          size="large"
        />
        <Button
          type="primary"
          size="large"
          className="ml-3 d-flex justify-content-center align-items-center"
          onClick={setRegistrar}
          icon={<PlusCircleOutlined style={{ fontSize: 24 }} />}
        >
          Registrar un producto
        </Button>
      </Row>
      <div className="mb-5">
        <TablaProductosAdmin
          productosRender={productosRender}
          showDeleteConfirm={showDeleteConfirm}
          setActualizar={setActualizar}
          setProductoID={setProductoID}
          setReload={setReload}
          setLoading={setLoading}
        />
      </div>

      <Pagination
        blogs={productos}
        location={location}
        history={history}
        limite={window.screen.width < 768 ? 12 : 28}
      />
    </Spin>
  );
}
export default withRouter(RegistrarProductos);
